import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Card, Typography, Stack, Button, TextField } from '@mui/material';
import EditLegalPagesForm from 'components/legalPages/EditLegalPagesForm'
import CommonLayout from 'layouts/DashboardLayout'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import CareerPageEdit from 'components/legalPages/CareerPageEdit';
import TeamPageEdit from 'components/legalPages/TeamPageEdit';
import AboutUsEdit from 'components/legalPages/AboutUsEdit';
import ReviewPageEdit from 'components/legalPages/ReviewPageEdit';
import MDButton from 'components/MDButton';
import { useSelector } from 'react-redux';
import AngleRightIcon from 'common/customIcons/angle_right';
import { grey } from '@mui/material/colors';
import { IsheadingExist } from '../../redux/slices/common';
import { debounce } from 'utilities/common';
import { useDispatch } from 'react-redux';
import { closeCustomModalDialog, openCustomModalDialog } from '../../redux/slices/modalSlice';

const EditEEATPage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [searchParams, setSearchParams] = useSearchParams();
  const fullRoleTabTemplate = useMemo(() => searchParams.get('template'), [searchParams]);
  const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);
  const fullRoleTabHeading = useMemo(() => searchParams.get('heading'), [searchParams]);
  const [error, setError] = useState(null);
  const [formData, setFormData] = useState({ status: true })
  const { singleLegal } = useSelector((state => state.common));

  
  const debouncedFnRef = useRef();
  
  // Initialize the debounced function only once
  useEffect(() => {
    debouncedFnRef.current = debounce((newHeading) => {
      
      dispatch(IsheadingExist({ platform: fullRoleTab, heading: newHeading }))
      .unwrap()
      .then((res) => {

          setError(null);
        })
        .catch((err) => {
          setSearchParams({
            template: fullRoleTabTemplate,
            roleTab: fullRoleTab,
            heading: newHeading,
            pageExist: 'yes'
          });

          setError(err?.message || "An error occurred");
        });
    }, 1000); // 500ms debounce delay

    // Cleanup on unmount
    return () => {
      // This will cancel any pending debounce when component unmounts
      if (debouncedFnRef.current) {
        debouncedFnRef.current.cancel = () => clearTimeout(debouncedFnRef.current.timeoutId);
        debouncedFnRef.current.cancel();
      }
    };
  }, [dispatch,fullRoleTab]);

  useEffect(() => {
    setSearchParams({
      template: fullRoleTabTemplate,
      roleTab: fullRoleTab,
      heading: "",
    });

  }, [fullRoleTab])
  const onHeadingChange = (e) => {
    const newHeading = e.target.value;
    setSearchParams({
      template: fullRoleTabTemplate,
      roleTab: fullRoleTab,
      heading: newHeading
    });

    // Call the debounced function
    debouncedFnRef.current(newHeading);
  };

  // ... rest of your component

  const saveHandler = (type, template, tab) => {
    if (type === 'Platform') {
      setSearchParams({ template: fullRoleTabTemplate, roleTab: tab, heading: fullRoleTabHeading ? fullRoleTabHeading : "" })
    }
    else {
      setSearchParams({ template: template, roleTab: 'hemp' })
    }
    dispatch(closeCustomModalDialog());
  }

  useEffect(()=>{
 dispatch(closeCustomModalDialog());
  },[])

  return (
    <CommonLayout>
      <Grid item xs={12} sm={4} md={2} xxl={2}>
        <Box p={{ xs: 2, sm: 3, lg: 4 }} style={{ paddingBottom: 0 }}>
          <Box display="flex" alignItems="center" justifyContent={'space-between'} mb={2}>
            <Box display="flex" alignItems="center" color='text.main' lineHeight={1}>
              <span style={{ cursor: 'pointer', display: "flex", alignItems: "center" }} onClick={() => { navigate('/manages/static') }}>
                <AngleRightIcon fontSize="14px" />
                <Typography variant='h6' fontWeight="semibold" ml={.75}>Static Pages</Typography>
              </span>
            </Box>
           
            
          </Box>

        </Box> 
        <Stack style={{ marginTop: "10px" }} pl={{ xs: 2, sm: 3, lg: 4 }} pr={{ xs: 2, sm: 3, lg: 4 }} direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent="space-between" gap={2}>
          <Box className="cannabinoids-tabs">
            <Stack direction='row' gap={1} sx={{ background: '#ffffff' }} className="mb-0">

              <Button className={fullRoleTab === 'hemp' ? 'active' : ''} onClick={() => {
              fullRoleTab !== 'hemp' &&    dispatch(openCustomModalDialog({ modalData: { Type: 'Platform', SwitchTab: 'hemp', saveHandler }, modal: 'CONFIRM_SAVE_MODAL' }))

                // setSearchParams({ template: fullRoleTabTemplate, roleTab: 'hemp', heading: fullRoleTabHeading ? fullRoleTabHeading : "" })
              }} variant='outlined' sx={{ color: '#2E2E3A', minWidth: '160px' }}>
                Hemp
              </Button>
              <Button onClick={() => {
                fullRoleTab !== 'hyperwolf' && dispatch(openCustomModalDialog({ modalData: { Type: 'Platform', SwitchTab: 'hyperwolf', saveHandler }, modal: 'CONFIRM_SAVE_MODAL' }))
                // setSearchParams({ template: fullRoleTabTemplate, roleTab: 'hyperwolf', heading: fullRoleTabHeading ? fullRoleTabHeading : "" })
              }} variant='outlined' sx={{ color: '#2E2E3A', minWidth: '160px' }} className={fullRoleTab === 'hyperwolf' ? 'active' : ''} >
                Hyperwolf
              </Button>
              <Button className={fullRoleTab === 'stilo' ? 'active' : ''}
                // disabled
                onClick={() => {
                  fullRoleTab !== 'stilo' && dispatch(openCustomModalDialog({ modalData: { Type: 'Platform', SwitchTab: 'stilo', saveHandler }, modal: 'CONFIRM_SAVE_MODAL' }))
                  // setSearchParams({ template: fullRoleTabTemplate, roleTab: 'hyperwolf', heading: fullRoleTabHeading ? fullRoleTabHeading : "" })
                }} 
                // onClick={() => { setSearchParams({ roleTab: 'stilo' ,heading:fullRoleTabheading}) }}
                variant='outlined' sx={{ color: '#2E2E3A', minWidth: '160px'}}>
                Stilo
              </Button>
            </Stack>
          </Box>

          <Box display='flex' alignItems='center' gap={1.25}>
            <Typography variant='h5' fontWeight='semibold' color='secondary'>Status</Typography>
            <Stack direction='row' alignItems='center' gap={.75} lineHeight={1} p={.75} borderRadius={2} bgcolor='#F2F3F7'>
              <MDButton
                sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                type='button'
                variant={formData?.status ? "contained" : "text"}
                color={formData?.status ? "success" : "dark"}
                size='small'
                onClick={() => setFormData((prev) => ({ ...prev, status: true }))}
              >
                Active
              </MDButton>
              <MDButton
                sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
                type='button'
                variant={!formData?.status ? "contained" : "text"}
                color={!formData?.status ? "error" : "dark"}
                size='small'
                onClick={() => setFormData((prev) => ({ ...prev, status: false }))}
              >
                Inactive
              </MDButton>
            </Stack>
          </Box>
        </Stack>
        
      </Grid>
      {/*  without slug custom */}

      <Box p={4} pt={2} pb={0} className="static-pages-container">
        <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: 'none' }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={4} className="static-template-heading">
                <Typography variant='h5' fontWeight="semibold" mb={2}>Template Name</Typography>
                <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ sm: 'center' }} justifyContent="space-between" gap={2}>
                  <div className='select-static-pages'>
                    <Box className='filter-pro-status'>
                      <FormControl fullWidth>
                        {/* <InputLabel>Select Static Template</InputLabel> */}
                        <Select disabled={true} size='small' value={fullRoleTabTemplate} onChange={(e) => {
                          dispatch(openCustomModalDialog({ modalData: { Type: 'Template', templatename: e.target.value, saveHandler }, modal: 'CONFIRM_SAVE_MODAL' }))
                        }} fullWidth className='form-select' name='status' label='Product Status' >
                          <MenuItem value='about_us_template'>About Us Template</MenuItem>
                          <MenuItem value='career_template'>Career Template</MenuItem>
                          <MenuItem value='meet_the_team_template'>Meet the Team Template</MenuItem>
                          <MenuItem value='review_template'>Review Template</MenuItem>
                          <MenuItem value='static_template'> Static Template</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                  </div>
                </Stack>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant='h5' fontWeight="semibold" mb={2}>Page Name</Typography>
                <TextField
                  label="Page Name*"
                  className="form-input"
                  fullWidth
                  placeholder="Page Name*"
                  value={fullRoleTabHeading ? fullRoleTabHeading : ""}
                  onChange={onHeadingChange}

                  // onChange={(e) => { setSearchParams({ template: fullRoleTabTemplate, roleTab: fullRoleTab, heading: e.target?.value }) }}
                  // error={Boolean(!fullRoleTabHeading ? true : false)}
                  // helperText={!fullRoleTabHeading ? "Heading is required" : ""}
                  error={!fullRoleTabHeading || Boolean(error)} // Check both fullRoleTabHeading and error state
                  helperText={
                    !fullRoleTabHeading
                      ? "Page Name is required"
                      : error
                        ? error // Display error message if present
                        : ""
                  }
                />
              </Grid>
            </Grid>
          </Card>
      </Box>


      {
        fullRoleTabTemplate === 'about_us_template' &&
        <AboutUsEdit dataProps={formData} />
      }
      {
        fullRoleTabTemplate === 'career_template' &&
        <CareerPageEdit dataProps={formData} />
      }
      {
        fullRoleTabTemplate === 'meet_the_team_template' &&
        <TeamPageEdit dataProps={formData} />
      }
         {
        fullRoleTabTemplate === 'review_template' &&
        <ReviewPageEdit dataProps={formData} />
      }
      {
        fullRoleTabTemplate === 'static_template' &&
        <EditLegalPagesForm dataProps={formData} />
      }
    </CommonLayout>
  )
}

export default EditEEATPage
